import { render, staticRenderFns } from "./DataLoader.vue?vue&type=template&id=68cc89fb"
import script from "./DataLoader.vue?vue&type=script&lang=js"
export * from "./DataLoader.vue?vue&type=script&lang=js"
import style0 from "./DataLoader.vue?vue&type=style&index=0&id=68cc89fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports